import styled from 'styled-components';

const StyledFileTable = styled.div`
    overflow: auto;
`;

export default StyledFileTable;
